import { render, staticRenderFns } from "./viewSale.vue?vue&type=template&id=42587fe8&scoped=true&"
import script from "./viewSale.vue?vue&type=script&lang=js&"
export * from "./viewSale.vue?vue&type=script&lang=js&"
import style0 from "./viewSale.vue?vue&type=style&index=0&id=42587fe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42587fe8",
  null
  
)

export default component.exports